export default "__VITE_ASSET__838299e4__"